module.exports = __webpack_public_path__ + "static/football-league-82f14a0cf33091896e03af5e8abd8594.jpg";